module.exports = __webpack_public_path__ + "img/cart_empty.7ecf262a.png";